<template>

</template>



<script >

import Vue from 'vue';

let addSMSContactMutationTxt = `
    mutation addSMSContactMutation($input: AddSMSContactInput) {
      addSMSContact(input: $input) {
        message_id
        to_id
        to_type
        from_id
        from_type
        text
        dated
        msg_group_id
        fromName
        toName
        groupBy
      }
    }
  `;

export default Vue.extend({
  data: function() {
    return {
    }
  },

  props: {
  },
  computed: {
    
  },
  components: {
    
  },
  methods: {
    
    addSMSContact: function(name, number, fromNumber) {
      let self = this;
      let msgGroupId = null;
      
      let variables = {
        input: {
            name: name,
            number: number,
            fromNumber: fromNumber,
        }
      };
      const gqlClient = global.gqlClient();
      gqlClient.request(addSMSContactMutationTxt, variables).then(function(result) {
        let m = result.addSMSContact;
        //console.log('message');
        //console.log(result);
        self.$store.commit('messageAdd', m);
        msgGroupId = m.msg_group_id;
      }).then(function() {
        // message group permissions for subscriptions are 
        // determined at the server level and are 
        // determined at the time of the initial subscription. If we are
        // adding a group, we need to resubscribe to get the server
        // to re-think the message groups the subscription should 
        // deliver to.
        self.$store.dispatch('resubscribeToMessages');

        // also, we got a message for the group which 
        // will dynamically create the group. But it doesn't
        // have info like MsgGroupMembers. So lets pull down the
        // latest set of groups from the server
        self.$store.dispatch('getMsgGroups');

        // close this form.
        self.$emit('closenewcontact', msgGroupId);
        console.log('added SMS Contact');
      });

    },
  },
  beforeMount() {
    
  },
});

</script>
